import { useCallback } from 'react';

import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';

import styles from './SearchFilters.module.scss';

interface ISearchFilterDatesProps {
  fromDate: string;
  toDate?: string;
  removeFilterValue: (title: string[]) => () => void;
}

export const SearchFilterDates = ({ fromDate, toDate, removeFilterValue }: ISearchFilterDatesProps) => {
  const onRemove = useCallback(() => {
    removeFilterValue(['fromDate', 'toDate'])();
  }, [removeFilterValue]);

  return (
    <div className={styles.FilterWrap}>
      <div className={styles.FilterLabel}>Период проведения</div>
      <div className={styles.FilterTextWrap}>
        <div className={styles.FilterText}>{`${formatDate({
          date: fromDate,
          dateFormat: DATE_FORMAT_LONG,
        })} - ${formatDate({ date: toDate || '', dateFormat: DATE_FORMAT_LONG })}`}</div>
        <div className={styles.FilterRemove} onClick={onRemove} />
      </div>
    </div>
  );
};
